import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as PlusIcon } from '../../../../assets/images/plusIcon.svg';
import CustomTextField from '../../../../components/shared/CustomTextField/CustomTextField';
import { createEmail, getEmails } from '../../../../redux/actions/userActions';

import EmailRow from './EmailRow/EmailRow';

import styles from './ChangeEmail.module.scss';

const ChangeEmail = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const [emailValue, setEmailValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const emailRef = useRef();

  const userId = useSelector((state) => state.authReducer.currentUser.user?.id);
  const userEmails = useSelector((state) => state.userReducer.emails);

  useEffect(() => {
    dispatch(getEmails(userId));
  }, [userId]);

  const successCallback = useCallback(() => {
    setErrorMessage('');
    setEmailValue('');
  }, []);

  const errorCallback = useCallback((error) => {
    setErrorMessage(error);
  }, []);

  const handleAddEmail = useCallback(() => {
    dispatch(createEmail(userId, emailRef.current.value, successCallback, errorCallback));
  }, [userId]);

  return (
    <div className={styles.container}>
      <p className={styles.contentHeading}>{t('account.changeOrAddEmail')}</p>
      <div className={styles.emailsContainer}>
        {userEmails.map((email) => (
          <EmailRow key={email.id} emailData={email} />
        ))}

        <div>
          <div className={styles.addEmail}>
            <CustomTextField
              value={emailValue}
              onChange={(e) => setEmailValue(e.target.value)}
              type="email"
              label={t('account.addNewEmail')}
              inputRef={emailRef}
              error={!!errorMessage}
              onFocus={() => setErrorMessage('')}
            />
            <span>
              <PlusIcon onClick={handleAddEmail} />
            </span>
          </div>
          {!!errorMessage && <p className={styles.error}>{errorMessage}</p>}
        </div>
      </div>
    </div>
  );
};

export default ChangeEmail;
